import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";
import FootLocation from './FootLocation';

export default class Foot extends Component {
	
	constructor(props) {
    	super(props);
		this.state = {
			error: null,
			isLoaded: false,
			footer: []
    	};
    	this.timer = null;
    };
        
    componentDidMount() {
    	fetch('/wp-json/bloomingdales/v1/footer')
		.then(res => res.json())
		.then(
			(result) => {
				this.setState({
					isLoaded: true,
					error: false,
					footer: result[0],
      			});
    		},
			(error) => {
				this.setState({
					isLoaded: true,
					error: true,
					footer: []
				});
			}
		)
    }
  	
    render() {
	    
	    const { error, isLoaded, footer } = this.state;
		if (error) {
			return null;
		} else if (!isLoaded) {
			return null;
		} else {
			
			const left_nav = footer.left_nav.map((item,i) =>
				<li key={i} className="c-footer__nav__item">
					<Link to={ item.url } className="c-footer__nav__link" dangerouslySetInnerHTML={ {__html: item.title} }></Link>
				</li>
			);
			
			const mobile_left_nav = footer.left_nav.map((item,i) =>
				<option key={i} value={ item.url } dangerouslySetInnerHTML={ {__html: item.title} }></option>
			);
			
			const middle_nav = footer.middle_nav.map((item,i) =>
				<li key={i} className="c-footer__nav__item">
					<Link to={ item.url } className="c-footer__nav__link" dangerouslySetInnerHTML={ {__html: item.title} }></Link>
				</li>
			);
			
			const mobile_middle_nav = footer.middle_nav.map((item,i) =>
				<option key={i} value={ item.url } dangerouslySetInnerHTML={ {__html: item.title} }></option>
			);
			
			const right_nav = footer.right_nav.map((item,i) =>
				<li key={i} className="c-footer__nav__item">
					<Link to={ item.url } className="c-footer__nav__link" dangerouslySetInnerHTML={ {__html: item.title} }></Link>
				</li>
			);
			
			const mobile_right_nav = footer.right_nav.map((item,i) =>
				<option key={i} value={ item.url } dangerouslySetInnerHTML={ {__html: item.title} }></option>
			);
							
		    return (<div className="c-footer">
		    	
		    	<div className="l-grid">
		    	
		    		<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--xl-3-12 c-footer__space c-footer__subscribe">
		    			
		    			<h4 className="c-footer__heading">Subscribe</h4>
		    			
		    			<div className="scope-subscribe">
		    				<GravityForm
								backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
								formID="1"
								jumpToConfirmation={false}
							/>
		    			</div>
		    		
		    		</div>
		    		
		    		<div className="l-grid__col"></div>
					
					<div className="l-grid__col u-m-hide">
						<p className="c-footer__faux-select">About Bloomingdales</p>
						<select className="c-footer__select">
							{ mobile_left_nav }
						</select>
					</div>
					
					<div className="l-grid__col u-m-hide">
						<p className="c-footer__faux-select">Customer Care</p>
						<select className="c-footer__select">
							{ mobile_middle_nav }
						</select>
					</div>
					
					<div className="l-grid__col u-m-hide">
						<p className="c-footer__faux-select">Our Collections</p>
						<select className="c-footer__select">
							{ mobile_right_nav }
						</select>
					</div>
					
					<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12 l-grid__col--xl-3-12 c-footer__space">
						<div className="c-footer__locations">
							{footer.location.map((location,i) =>
								{
									if (i === 0) {
										return (	
											<div key={i} className="c-footer__locations__section">
												<FootLocation location={location}></FootLocation>
											</div>
										)
									} else {
										return null;
									}
								}
							)}
						</div>
					</div>
					
					<div className="l-grid__col u-l-hide"></div>
					
					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-5-24 l-grid__col--xl-2-12 u-m-show c-footer__space">
						{left_nav &&
							<div className="c-footer__nav">
								<h5 className="c-footer__nav__heading"><Link to={ '/' }>About Us</Link></h5>
								<ul className="c-footer__nav__list">
									{ left_nav }
								</ul>
							</div>
						}
					</div>
					
					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-5-24 l-grid__col--xl-2-12 u-m-show c-footer__space">
						{middle_nav &&
							<div className="c-footer__nav">
								<h5 className="c-footer__nav__heading"><Link to={ '/' }>Customer Care</Link></h5>
								<ul className="c-footer__nav__list">
									{ middle_nav }
								</ul>
							</div>
						}
					</div>
					
					<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-3-12 l-grid__col--xl-2-12 u-m-show c-footer__space">
						{right_nav &&
							<div className="c-footer__nav">
								<h5 className="c-footer__nav__heading"><Link to={ '/' }>Our Collections</Link></h5>
								<ul className="c-footer__nav__list">
									{ right_nav }
								</ul>
							</div>
						}
					</div>
					
				</div>
		    
		    </div>)
		}
	}
}